<script>
import { Line } from 'vue-chartjs';

export default {
  extends: Line,
  props: ['chartQuantity', 'chartLabel', 'reportName'],
  methods: {
    renderLineChart: function() {
      this.renderChart(
        {
          labels: this.chartLabel,
          datasets: [
            {
              label: `No of ${this.reportName}s`,
              fill: true,
              borderColor: '#2196f3', // Add custom color border (Line)
              backgroundColor: this.gradient, // Add custom color background (Points and Fi120
              borderWidth: 2, // Specify bar border width
              data: this.chartQuantity,
              pointBackgroundColor: "#005066",
            },
          ],
        },
        { responsive: true, maintainAspectRatio: false }
      );
    },
  },
  mounted() {
    Event.$on('initLineChart', () => {
      console.log('on Line chart');
      this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)

      this.gradient.addColorStop(0, 'rgba(120, 181, 156, 0.90)')
      this.gradient.addColorStop(0.5, 'rgba(120, 181, 156, 0.50)');
      this.gradient.addColorStop(1, 'rgba(120, 181, 156, 0)');
      this.renderLineChart();
    });
  },
};
</script>
